<template>
  <span :class="{badge:true, 'badge-pill':true, 'badge-primary': typ == 'thc','badge-success':typ == 'cbd'}">{{to1dp(amount).toLocaleString()}}mg {{typ.toUpperCase()}}</span>
</template>

<script>
export default {
    props:{
        amount: Number,
        typ: String
    },
    methods:{
        to1dp(num){
            return Math.round(num*10) / 10
        }
    }
}
</script>

<style>

</style>